import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { BidLineItemType } from "@miplatform/types";
import { IBidLineItemPayload } from "../CustomerPricingDetails/CustomerPricingDetails.types";

export const BidLineItemForm = ({
  open,
  form,
  categories,
  disabled,
}: BidLineItemFormProps) => {
  if (!open) {
    return null;
  }

  const categoryOptions = categories.map((c) => ({
    label: c.name,
    value: c.id,
  }));

  const { control, watch } = form;
  const { bidLineItemType } = watch();

  const fields = [
    {
      label: `${
        bidLineItemType === BidLineItemType.Bid ? "Bid" : "Option"
      } Line Item Name`,
      name: "name",
      formControl: control,
      required: true,
      InputProps: {
        inputProps: {
          maxLength: 128,
        },
      },
      width: "50%",
      disabled,
    },
    {
      label: "Footnote",
      name: "footnote",
      formControl: control,
      width: "50%",
      disabled,
    },
    {
      label: "Categories",
      name: "categoryIds",
      formControl: control,
      required: true,
      fieldType: INPUT_TYPES.MULTI_SELECT,
      options: categoryOptions,
      width: "100%",
      disabled: disabled || categoryOptions.length === 0,
    },
  ];

  return <MiDetailFields detailFields={fields} />;
};

interface BidLineItemFormProps {
  open: boolean;
  form: UseFormReturn<IBidLineItemPayload>;
  categories: {
    id: string;
    name: string;
  }[];
  disabled: boolean;
}
